import { useCallback, useEffect, useState } from 'react';

export const useHubSpot = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  const loadHubSpot = useCallback(() => {
    if (isLoaded || document.querySelector('script[src*="hsforms.net"]')) {
      return;
    }

    // Load the main HubSpot forms script
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.onload = () => {
      setIsLoaded(true);
      
      // Also load the embed script after the main script loads
      const embedScript = document.createElement('script');
      embedScript.src = 'https://js-na2.hsforms.net/forms/embed/243578332.js';
      document.body.appendChild(embedScript);
    };
    document.body.appendChild(script);
  }, [isLoaded]);

  useEffect(() => {
    // Check if consent was already given on component mount
    if (localStorage.getItem('cookieConsent') === 'true') {
      loadHubSpot();
    }
  }, [loadHubSpot]);

  return { loadHubSpot, isLoaded };
};